<template>
  <div id="app">
    <private v-if="!$route.meta.isPublic">
      <router-view></router-view>
    </private>
    <public v-if="$route.meta.isPublic">
      <router-view></router-view>
    </public>
    <div class="spinning" v-if="spinning">
      <a-spin tip="Loading..." size="large" :spinning="spinning" :delay="delayTime" />
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        delayTime: 0
      };
    },
    computed: {
      spinning() {
        return this.$store.state.loading.stateLoading;
      }
    }
  };
</script>

<style lang="scss">
  #app {
    font-family: 'Roboto', sans-serif !important;
    height: 100%;
    color: $pr;
  }
</style>
